import type { SourceId } from '../../../../constants';
import { fetchWithWidgetToken, poll } from '../../../helpers';
import type {
  DataServiceSourceStatusResponse,
  DataServiceSourceStatusType
} from '../../../types';

type DataServicePostsFetcherArgs = {
  statusURL: string;
  status: DataServiceSourceStatusType;
  postsURL: string;
  widgetToken: string;
  platform: SourceId;
};

export function getDataServicePostsFetcher({
  statusURL,
  status: settingsStatus,
  postsURL,
  widgetToken,
  platform
}: DataServicePostsFetcherArgs) {
  return async () => {
    if (settingsStatus === 'failure') {
      throw new Error(`An error occurred while creating ${platform} source`);
    }

    if (settingsStatus !== 'success') {
      try {
        await poll<DataServiceSourceStatusResponse>(
          statusURL,
          widgetToken,
          (data) => data.payload.every(({ status }) => status !== 'pending')
        );
      } catch {
        throw new Error(`Too many attempts to fetch a ${platform} source`);
      }
    }

    const postsResponse = await fetchWithWidgetToken({
      url: postsURL,
      widgetToken
    });

    if (!postsResponse.ok) {
      throw new Error(
        `An error occurred while collecting ${platform} source: ${postsResponse.status}`
      );
    }

    return postsResponse;
  };
}
